import { functions, httpsCallable } from '@/firebase'

export function getTaxPaymentCloudFunction(data) {
    const fn = httpsCallable(functions, 'getTaxPayment')
    return fn(data).then((result) => result.data)
}
